import React, { useEffect, useMemo, useRef, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorMessage } from "@hookform/error-message";
import { Table, Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { Controller } from "react-hook-form";
import moment from "moment";
import Moment from "react-moment";
import { createInventoryOptions, createOptions, showPrice } from "../../utils/utils";
import Select from "react-select";
import ReactGA from "react-ga4";
import { addInAndOutStockService, getSupplierItem } from "API/services/newServices";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { mainUrl } from "API/client/api";
import axios from "axios";
import { toast } from "react-toastify";

const validation1 = Yup.object().shape({
  price: Yup.string().required("Please Enter Price*"),
  totalAmount: Yup.string().required("Please Enter Total Amount*"),
  quantity: Yup.string().required("Please Enter Quntity*"),
  unit: Yup.string().required("Please Enter Unit*"),
  supplierId: Yup.object().required("Please select Supplier *"),
  item: Yup.object().required("Please select Item*"),
  // expDate: Yup.string().required("Please select expiry date*"),
  selectCategory: Yup.string().required("Please select Category*"),
  stockStatus: Yup.string().required("Please select Stock type*"),
});

const validation2 = Yup.object().shape({
  price: Yup.string().required("Please Enter Price*"),
  quantity: Yup.string().required("Please Enter Quntity*"),
  supplierId: Yup.object().required("Please select Supplier *"),
  item: Yup.object().required("Please select Item*"),
  stockStatus: Yup.string().required("Please select Stock type*"),
  selectReason: Yup.string().required("Please select reason to out*"),
  remark: Yup.string().required("Enter Remark*"),
});

const STOCK_STATUS = ["IN", "OUT"];

const instockValidation = { resolver: yupResolver(validation1) };
const outstockValidation = { resolver: yupResolver(validation2) };

const Inventory = () => {
  const [tableData, setTableData] = useState([]);
  const [stockTableData, setStockTableData] = useState([]);
  const [stockTableDataFilter, setStockTableDataFilter] = useState([]);
  const [suppilerData, setSuppilerData] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchText, setSearchText] = useState("")
  const [validation, setValidation] = useState(instockValidation);
  const { userDetail } = useSelector(authenticationSeletor);

  const getEmplyoee = async () => {
    try {
      const data = await services.property.getInventoryEmplyoee();
      const onlyProperty = data?.data?.result?.filter((item) => { return item?.propertyId == userDetail?.propertyId });
      const dataSet = createOptions(onlyProperty, "firstName", "id");
      setSuppilerData(dataSet);
      setEmpData(dataSet)
    } catch (error) { console.log("Error in getEmplyee function") }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDataHandler(userDetail?.propertyId);
    getDataHandlers(userDetail?.propertyId);
    getDataHandlerSupplier(userDetail?.propertyId);
  }, []);

  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [itemDataMaster, setItemDataMaster] = useState([]);
  const [remarkShow, setRemarkShow] = useState(false);
  const { register, handleSubmit, reset, setValue, control, watch, formState: { errors } } = useForm({ ...validation, mode: "onSubmit" });

  const getDataHandler = async (id) => {
    try {
      const res = await services.globalService.getInventoryCategoryService(id);
      if (res.status == 200) { setTableData(res.data.data) }
    } catch (error) { console.log("Error in getDataHandler function") }
  };

  const onSubmit = async (payload) => {
    const stockSt = +payload.stockStatus;
    let realPayload = {
      propertyId: userDetail?.propertyId,
      categoryId: payload.selectCategory,
      employeeId: 0,
      suplierId: payload?.supplierId?.value,
      itemName: payload.item?.label,
      itemId: payload.item?.value,
      // avaiableQuantity: payload.avaiableQuantity,
      remark: payload.remark ?? "",
      status: 0,
      reasonToOutStock: payload.selectReason,
      unit: payload.unit,
      quantity: +payload.quantity,
      price: +payload.price,
      totalAmount: payload.totalAmount,
      mfdDate: moment().format("YYYY-MM-DD"),
      expDate: moment(payload.expDate).format("YYYY-MM-DD"),
      createdBy: userDetail.id,
      inStock: true,
    };

    if (stockSt == 2) {
      realPayload = {
        propertyId: userDetail?.propertyId,
        employeeId: payload?.supplierId?.value,
        itemId: payload.item?.value,
        quantity: payload.quantity,
        remark: payload.remark ?? "",
        status: 0,
        reasonToOutStock: payload.selectReason,
        updatedBy: userDetail.id,
      };
    }

    const res = await addInAndOutStockService(realPayload);
    if (res) {
      reset();
      // setEditMode(false);
      getDataHandlers(userDetail?.propertyId);
      setShow(false);
      // setSelectedData({});
    }
  };

  const { quantity, price, selectCategory, stockStatus, supplierId, totalAmount, selectReason, remark, expDate } = watch();

  useEffect(() => {
    if (show) {
      setValue("selectCategory", "");
      setValue("item", "");
      setValue("supplierId", "");
      if (+stockStatus == 2) {
        getEmplyoee();
        setRemarkShow(true);
        setValidation(outstockValidation);
      } else {
        getDataHandlerSupplier(userDetail.propertyId);
        setRemarkShow(false);
        setValidation(instockValidation);
      }
      setItemsData([]);
    }
  }, [stockStatus]);

  useMemo(() => { setValue("totalAmount", quantity * price) }, [quantity, price]);

  const getDataHandlers = async (id) => {
    try {
      const res = await services.globalService.getInStockService(id);
      if (res.status == 200) { setStockTableData(res.data.data); }
    } catch (error) { console.log("Error in getDataHandlers function") }
  };

  const getDataHandlerSupplier = async (id) => {
    try {
      const res = await services.globalService.getSupplierByPropertyIdService(id);
      if (res.status == 200) { const dataSet = createOptions(res.data.data, "name", "id"); setSuppilerData(dataSet) }
    } catch (error) { console.log("Error in getDataHandlerSupplier function") }
  };

  const getDataHandlerItems = async (id) => {
    const res = await getSupplierItem(id);
    if (res) {
      setItemDataMaster(res);
      setItemsData(createInventoryOptions(res, "InventoryItem", "itemId", "itemName"));
    }
  };

  const getItemsByCategory = async (id) => {
    const res = await services.globalService.getInventoryItemByPropertyIdService(userDetail?.propertyId);
    if (res.status == 200) {
      const onlyInstocks = res.data.data.filter((i) => stockTableData.some((item) => item.itemId == i.id));
      const filtered = onlyInstocks.filter((i) => i.categoryId == id);
      setItemDataMaster(onlyInstocks);
      setItemsData(createOptions(filtered, "itemName", "id"));
    }
  };

  useEffect(() => { if (supplierId?.value && show && !remarkShow) { getDataHandlerItems(supplierId?.value); } }, [supplierId?.value]);

  useEffect(() => {
    if (selectCategory && show) {
      if (+stockStatus == 1) {
        const filter = itemDataMaster.filter((i) => i.categoryId == selectCategory);
        setItemsData(createInventoryOptions(filter, "InventoryItem", "itemId", "itemName"));
      } else { getItemsByCategory(selectCategory); }
    }
  }, [selectCategory]);

  const [categoryID, setCategoryID] = useState('')
  const handleSelectChange = (e) => { const selectedValue = e.target.value; setCategoryID(selectedValue) };

  const [cateItems, setCateItems] = useState([])
  const fetchItemsByCategoryService = async () => {
    if (categoryID) {
      const res = await services.globalService.itemsByCategoryService(categoryID);
      if (res.data.status == true) { setCateItems(res.data.data) }
    }
  }

  useEffect(() => { fetchItemsByCategoryService() }, [categoryID, selectCategory])

  const itemChangeHandler = (data) => {
    if (remarkShow) {
      let getSelected = cateItems?.find((dataSet) => dataSet?.id == data.value);
      setValue("price", getSelected?.price);
    } else {
      let getSelected = cateItems.find((dataSet) => dataSet?.id == data?.value);
      setValue("unit", getSelected?.unit);
      setValue("price", getSelected?.price);
    }
  };

  const tableRef = useRef();

  const exportTable = () => {
    // window.open(GlobalDictinary.exportInventoryExcle(userDetail.propertyId,fromDate,toDate));
    window.open(`${mainUrl}api/kpi/inventory-report?propertyId=${userDetail?.propertyId}${fromDate ? "&fromDate=" + moment(fromDate).format("YYYY-MM-DD") : ""}${toDate ? "&toDate=" + moment(toDate).format("YYYY-MM-DD") : ""}${searchText ? "&search=" + searchText : ""}`, "_blank")
    setToDate(null); setFromDate(null); setSearchText("")
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "inventory" });
    setStockTableDataFilter(stockTableData);
  }, [stockTableData]);

  const searchfilter = (text, fromHeads = false, innerKey = null) => {
    const resultsData = stockTableData.filter((order) => {
      if (text == "") return stockTableData;
      let params = innerKey ? order[fromHeads]?.[innerKey] : order[fromHeads];
      if (fromHeads == "stockType") { params = STOCK_STATUS[order.stockType]; }
      if (!fromHeads) {
        params =
          order?.itemId +
          order?.itemName +
          order?.categoryId +
          order.unit +
          order.price +
          order.totalAmount +
          order.quantity +
          order?.Suplier?.name +
          order?.InventoryCategory?.name;
      }
      return params?.toString().toLowerCase()?.includes(text?.toLowerCase());
    });
    setSearchText(text);
    setStockTableDataFilter(resultsData);
  };

  const setChangeHeadsVal = (e) => {
    const name = e.target.name;
    let innerKey = null;
    if (name == "Suplier" || name == "InventoryCategory") { innerKey = "name"; }
    searchfilter(e.target.value, name, innerKey);
  };

  const itemOptions = cateItems.map(item => ({ value: item.id, label: item.itemName }));

  const [selectedRow, setSelectedRow] = useState(null);
  const [showOutStock, setShowOutStock] = useState(false)
  const [showInStock, setShowInStock] = useState(false)

  useEffect(() => {
    if (!selectedRow) return;
    // setValue("supplierId", selectedRow.Suplier ? { label: selectedRow.Suplier.name, value: selectedRow.Suplier.id } : null);
    setValue("selectCategory", selectedRow.categoryId || "");
    setValue("item", selectedRow.itemId ? { label: selectedRow.itemName, value: selectedRow.itemId } : null);
    setValue("price", selectedRow.price);
    setValue("quantity", selectedRow.quantity);
    setValue("totalAmount", selectedRow.totalAmount);
    if (selectedRow.stockType == 1) {
      setValue("unit", selectedRow.InventoryItem.unit);
      // setValue("expDate", selectedRow.expDate ? new Date(selectedRow.expDate) : undefined);
    } else {
      setValue("selectReason", selectedRow.reason || "");
      setValue("remark", selectedRow.remark || "");
      setValue("unit", selectedRow.InventoryItem.unit);
      setValue("expDate", selectedRow.expDate ? new Date(selectedRow.expDate) : undefined);
    }
  }, [selectedRow]);

  const handleEdit = (data) => {
    reset();
    setSelectedRow(data);
    // setValue("supplierId", data.Suplier ? { label: data.Suplier.name, value: data.Suplier.id } : null);
    setValue("selectCategory", data.categoryId || "");
    setValue("item", data.itemId ? { label: data.itemName, value: data.itemId } : null);
    setValue("price", data.price);
    setValue("quantity", data.quantity);
    setValue("totalAmount", data.totalAmount);
    if (data.stockType == 1) {
      setValue("unit", data.InventoryItem.unit);
      // setValue("expDate", data.expDate ? new Date(data.expDate) : undefined);
    } else {
      setValue("selectReason", data.reason || "");
      setValue("remark", data.remark || "");
      setValue("unit", data.InventoryItem.unit);
      setValue("expDate", data.expDate ? new Date(data.expDate) : undefined);
    }
  };

  // console.log("price - ", price);
  // console.log("quantity - ", quantity)
  // console.log("totalAmount - ", totalAmount)
  // console.log("selectReason - ", selectReason)
  // console.log("remark - ", remark)
  // console.log("expDate - ", expDate)

  const closeInStockModal = () => {
    setShowInStock(false);
    reset();
    setSelectedRow(null);
  };

  const closeOutStockModal = () => {
    setShowOutStock(false);
    reset();
    setSelectedRow(null);
  };

  const handleUpdate = async (e) => {
    e.preventDefault()
    try {
      const payload = {
        id: selectedRow?.id,
        price,
        quantity,
        totalAmount,
        selectReason: selectReason ?? null,
        remark: remark ?? "0",
        propertyId: userDetail?.propertyId,
        categoryId: selectedRow?.categoryId,
        suplierId: selectedRow?.suplierId,
        itemId: selectedRow?.itemId,
        employeeId: selectedRow?.employeeId,
        avaiableQuantity: selectedRow?.stockType ? selectedRow?.avaiableQuantity + selectedRow?.quantity - quantity : selectedRow?.avaiableQuantity,
        stockType: selectedRow?.stockType,
        status: selectedRow?.status,
        expDate: expDate ? expDate : selectedRow?.expDate
      };
      let res = await axios.put(`${mainUrl}api/inventory/inventory-stock/${selectedRow?.id}`, payload)
      if (res.status == 200) {
        getDataHandlers(userDetail?.propertyId);
        toast.success("Stock updated successfully!")
        closeOutStockModal();
        closeInStockModal()
      }
    }
    catch (error) { console.log("error in handleUpdate function.") }
  }

  const handleDelete = async (data) => {
    try {
      let res = await axios.post(`${mainUrl}api/inventory/delete-inventory-stock/${data?.id}`)
      if (res.status == 200) {
        getDataHandlers(userDetail?.propertyId);
        toast.success("Inventory Stock deleted successfully!")
      }
    }
    catch (error) { console.log("Error in handleDelete function") }
  }

  return (
    <Layout title="Inventory" openHandler={() => setShow(true)} extraBtnHandler={exportTable} extraButton={fromDate || toDate || searchText ? "Export Table" : false} searchfilter={searchfilter} searchType="both" searchPlaceHolder="Search..." setFromDate={setFromDate} setToDate={setToDate} fromDate={fromDate} toDate={toDate}>
      <div className="">
        <Table striped bordered hover className="common-table" ref={tableRef}>
          <thead>
            <tr>
              <th>
                <span>Supplier Name/Id</span>
                {/* <input onChange={setChangeHeadsVal} name="Suplier" type="text" placeholder="Supplier Name/Id" className="pl-1"/> */}
              </th>
              <th>
                <span>Category</span>
                {/* <input onChange={setChangeHeadsVal} name="InventoryCategory" type="text" placeholder="Category" className="pl-1"/> */}
              </th>
              <th>
                <span>Item</span>
                {/* <input onChange={setChangeHeadsVal} name="itemName" type="text" placeholder="Item" className="pl-1"/> */}
              </th>
              <th>
                <span>Unit</span>
                {/* <input onChange={setChangeHeadsVal} name="unit" type="text" placeholder="Unit" className="pl-1"/> */}
              </th>
              <th>
                <span>Quantity</span>
                {/* <input onChange={setChangeHeadsVal} name="quantity" type="number" placeholder="Quantity" className="pl-1"/> */}
              </th>
              <th>
                <span>Availabe Quantity</span>
                {/* <input onChange={setChangeHeadsVal} name="avaiableQuantity" type="number" placeholder="Availabe Quantity" className="pl-1" /> */}
              </th>
              <th>
                <span>Price</span>
                {/* <input onChange={setChangeHeadsVal} name="price" type="number" placeholder="Price" className="pl-1" /> */}
              </th>
              <th>
                <span>Total amount</span>
                {/* <input onChange={setChangeHeadsVal} name="totalAmount" type="number" placeholder="Total amount" className="pl-1" /> */}
              </th>
              <th>
                <span>Exp.Date</span>
              </th>
              <th>
                <span>Date</span>
              </th>
              <th>
                <span>Status</span>
                {/* <input onChange={setChangeHeadsVal} name="stockType" type="text" placeholder="Status" className="pl-1" /> */}
              </th>
              <th>
                <span>Remark</span>
                {/* <input onChange={setChangeHeadsVal} name="remarks" type="text" placeholder="Remark" className="pl-1" /> */}
              </th>
              <th>
                <span>Reason for out stock</span>
                {/* <input onChange={setChangeHeadsVal} name="reasonToOutStock" type="text" placeholder="Reason for out" className="pl-1" /> */}
              </th>
              <th><span>Action</span></th>
            </tr>
          </thead>
          <tbody>
            {[...stockTableDataFilter].reverse().map((data, key) => (
              <tr key={key}>
                <td style={{ maxWidth: "100px" }}>{suppilerData.find((i) => i.value == data?.suplierId)?.label}{" "}#{data?.suplierId}</td>
                <td>{data.InventoryCategory?.name}</td>
                <td>{data.itemName}</td>
                <td>{data.unit}</td>
                <td>{data.quantity ?? "N/A"}</td>
                <td>{data.avaiableQuantity ?? "N/A"}</td>
                <td>{showPrice(data.price)}</td>
                <td>{showPrice(data.totalAmount)}</td>
                <td>{data.expDate && (<Moment format="DD MMM, YYYY">{data.expDate}</Moment>)}</td>
                <td>{data.createdAt && (<Moment format="DD MMM, YYYY">{data.createdAt}</Moment>)}</td>
                <td className={`inStock fw-bold ${!data.stockType ? "text-success" : "text-danger"}`}>{STOCK_STATUS[data.stockType]}</td>
                <td>{data.remarks ?? "N/A"}</td>
                <td>{data.reasonToOutStock ?? "N/A"}</td>
                <td>
                  <button className="btn btn-sm btn-primary mr-2" onClick={() => {
                    setSelectedRow(data); handleEdit(data); reset();
                    if (data.stockType == 1) { setShowOutStock(true); }
                    else { setShowInStock(true); }
                  }}>Edit</button>
                  <button className="btn btn-sm btn-danger" onClick={() => { handleDelete(data) }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <Modal show={show} onHide={() => { setShow(false); reset(); setEditMode(false); setValue("selectCategory", "") }} size="lg">
        <Modal.Header closeButton><Modal.Title>{editMode ? "Edit In Stock Form" : "Add Stock"}</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm instock" onSubmit={handleSubmit(onSubmit)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group">
                  <label>Select Stock Status</label>
                  <select {...register("stockStatus")}>
                    <option selected value="" disabled>Select</option>
                    <option value={1}>In-Stock</option>
                    <option value={2}>out-Stock</option>
                  </select>
                  {errors?.stockStatus?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"stockStatus"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label>Select {remarkShow ? "Employee" : "Supplier"}</label>
                  <Controller
                    control={control}
                    name="supplierId"
                    render={({ field: { onChange, value } }) => (
                      <Select options={suppilerData} placeholder={"Select"} value={value} onChange={onChange} isSearchable={true} />
                    )}
                  />
                  {errors?.supplierId?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"supplierId"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label>Select Category</label>
                  <select {...register("selectCategory")} value={categoryID} onChange={handleSelectChange}>
                    <option value="">
                      Select
                    </option>
                    {tableData.map((data, key) => (
                      <option value={data.id} key={key}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                  {errors?.selectCategory?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"selectCategory"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label>Item</label>
                  <Controller
                    control={control}
                    name="item"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        options={itemOptions}
                        placeholder={"Select"}
                        value={value}
                        onChange={(dataSet) => {
                          onChange(dataSet);
                          itemChangeHandler(dataSet);
                        }}
                        isSearchable={true}
                      />
                    )}
                  />
                  {errors?.item?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"item"} />
                      </span>
                    </div>
                  )}
                </Col>
                {!remarkShow && (
                  <Col xs={3} className="form-group">
                    <InputField
                      htmlFor="unit"
                      text="Unit"
                      type="text"
                      // placeholder="gm"
                      field={"unit"}
                      register={register}
                      errors={errors}
                      disabled={true}
                    />
                    {errors?.unit?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"unit"} />
                        </span>
                      </div>
                    )}
                  </Col>
                )}
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="price"
                    text="Price"
                    type="text"
                    // placeholder="₹500.00"
                    field={"price"}
                    register={register}
                    errors={errors}
                  // disabled={true}
                  />
                  {errors?.price?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"price"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="quantity"
                    text="Quantity"
                    type="number"
                    placeholder="Enter quantity"
                    field={"quantity"}
                    register={register}
                    errors={errors}
                  />
                  {errors?.quantity?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"quantity"} />
                      </span>
                    </div>
                  )}
                </Col>
                {!remarkShow && (
                  <Col xs={6} className="form-group">
                    <label>Exp. Date</label>
                    <Controller control={control} name="expDate" render={({ field: { onChange, value } }) => (
                      <DatePicker className="form-control" customclassName="form-control" onChange={(date) => onChange(date)} selected={value} />
                    )}
                    />
                    {errors?.expDate?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span><ErrorMessage errors={errors} name={"expDate"} /></span>
                      </div>
                    )}
                  </Col>
                )}
                <Col xs={6} className="form-group">
                  <InputField htmlFor="totalAmount" text="Total Amount" type="number" autoFocus={true} field={"totalAmount"} register={register} errors={errors} />
                  {errors?.totalAmount?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"totalAmount"} /></span>
                    </div>
                  )}
                </Col>
                {remarkShow && (
                  <>
                    <Col xs={6} className="form-group">
                      <label>Reason to out stock</label>
                      <select {...register("selectReason")}>
                        <option value="" selected>select reason</option>
                        <option value="consume">Consume</option>
                        <option value="expired">Expired</option>
                        <option value="damage">Damage</option>
                        <option value="transfer">Transfer</option>
                      </select>
                      {errors?.selectReason?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={"selectReason"} /></span>
                        </div>
                      )}
                    </Col>
                    <Col xs={12} className="form-group">
                      <InputField htmlFor="remark" text="Remark" type="textArea" autoFocus={true} placeholder="reason to out stock" field={"remark"} register={register} errors={errors} />
                      {errors?.remark?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span><ErrorMessage errors={errors} name={"remark"} /></span>
                        </div>
                      )}
                    </Col>
                  </>
                )}
                <Col xs={12} className="form-group flex justify-content-between mt-4">
                  <Button variant="primary" type="submit">Submit</Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showInStock} onHide={closeInStockModal} size="lg">
        <Modal.Header closeButton><Modal.Title>Update In-Stock</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm instock">
            <Container>
              <Row>
                {/* <Col xs={6} className="form-group">
                  <label>Select Supplier</label>
                  <Controller
                    control={control}
                    name="supplierId"
                    render={({ field }) => (
                      <Select{...field} options={suppilerData} placeholder="Select Supplier" isSearchable isDisabled={true} />
                    )}
                  />
                </Col> */}
                <Col xs={6} className="form-group">
                  <label>Select Category</label>
                  <select {...register("selectCategory")} onMouseDown={(e) => e.preventDefault()}
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "#666",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none"
                    }}>
                    <option value="">Select</option>
                    {tableData.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xs={6} className="form-group">
                  <label>Item</label>
                  <Controller
                    control={control}
                    name="item"
                    render={({ field }) => (
                      <Select {...field} options={itemOptions} placeholder="Select" isSearchable isDisabled={true} />
                    )}
                  />
                </Col>
                <Col xs={6} className="form-group">
                  <label>Exp. Date</label>
                  <Controller
                    control={control}
                    name="expDate"
                    render={({ field }) => (
                      <DatePicker
                        selected={field.value || null}
                        onChange={(date) => field.onChange(date)}
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                      />
                    )}
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="unit"
                    text="Unit"
                    type="text"
                    field="unit"
                    customClass="bg-disable"
                    register={register}
                    disabled
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="quantity"
                    text="Quantity"
                    type="number"
                    field="quantity"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="price"
                    text="Price"
                    type="text"
                    field="price"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField htmlFor="totalAmount" customClass="bg-disable" disabled text="Total Amount" type="number" autoFocus={true} field={"totalAmount"} register={register} errors={errors} />
                  {errors?.totalAmount?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"totalAmount"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={12} className="text-end my-3"><Button type="button" onClick={(e) => handleUpdate(e)}>Submit</Button></Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showOutStock} onHide={closeOutStockModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update Out-Stock</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm instock">
            <Container>
              <Row>
                {/* <Col xs={6} className="form-group">
                  <label>Select Employee</label>
                  <Controller
                    control={control}
                    name="supplierId"
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={empData}
                        placeholder="Select Employee"
                        isSearchable
                        isDisabled={true}
                      />
                    )}
                  />
                </Col> */}
                <Col xs={6} className="form-group">
                  <label>Select Category</label>
                  <select {...register("selectCategory")} onMouseDown={(e) => e.preventDefault()}
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "#666",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none"
                    }}>
                    <option value="">Select</option>
                    {tableData.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col xs={6} className="form-group">
                  <label>Item</label>
                  <Controller
                    control={control}
                    name="item"
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={itemOptions}
                        placeholder="Select"
                        isSearchable
                        isDisabled={true}
                      />
                    )}
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="price"
                    text="Price"
                    type="text"
                    field="price"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col xs={3} className="form-group">
                  <InputField
                    htmlFor="quantity"
                    text="Quantity"
                    type="number"
                    field="quantity"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col xs={6} className="form-group">
                  <InputField htmlFor="totalAmount" disabled customClass="bg-disable" text="Total Amount" type="number" autoFocus={true} field={"totalAmount"} register={register} errors={errors} />
                  {errors?.totalAmount?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span><ErrorMessage errors={errors} name={"totalAmount"} /></span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label>Reason to out stock</label>
                  <select {...register("selectReason")}>
                    <option value="">Select Reason</option>
                    <option value="consume">Consume</option>
                    <option value="expired">Expired</option>
                    <option value="damage">Damage</option>
                    <option value="transfer">Transfer</option>
                  </select>
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="remark"
                    text="Remark"
                    type="textArea"
                    field="remark"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col xs={12} className="text-end my-3"><Button type="button" onClick={(e) => handleUpdate(e)}>Update</Button></Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

    </Layout>
  );
};

export default Inventory;
